import {createGlobalStyle} from 'styled-components'
import theme from '../components/theme'
import media from '../components/theme-media'

const GlobalStyle = createGlobalStyle`
  :root {
    font-size: 10px; 
    color: ${theme.color.grey.darkest};
    background: ${theme.color.grey.lightest};
    letter-spacing: ${theme.font.letter.spacing.default};
    word-spacing: ${theme.font.word.spacing.default};

    --padding-large: ${theme.padding.large}; 
    --section-padding: ${theme.padding.large} ${theme.padding.small}; 
  }

  ${media.phone`
    :root {
      font-size: 8px;
      --padding-large: 6rem;
      --section-padding: ${theme.padding.medium} ${theme.padding.smallest}; 
    }
  `}

  ${media.tablet`
    :root {
      font-size: 8px;
      --padding-large: 7.5rem;
    }
  `}

  ${media.laptop`
    :root {
      font-size: 10px;
      --padding-large: 8.5rem;
    }
  `}
`

export default GlobalStyle